import { FaSync } from "react-icons/fa"
import useShipmentSnackbar from "../Shared/useShipmentSnackbar";
import useFetchOpportunities from "../Shared/useFetchOpportunities";

export const useRefreshOpportunity = () => {
  const shipmentSnackbar = useShipmentSnackbar()
  const { fetchOpportunityRefreshCache } = useFetchOpportunities()

  const fetchOpportunityRefresh = async (opportunityId) => {
    try {
      const result = await fetchOpportunityRefreshCache({ opportunityId })

      if (result.error) {
        throw new Error(result.error)
      }
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error refreshing order(s)', severity: 'failure' })
      return { error: e }
    }
  }

  return fetchOpportunityRefresh
}

export default ({
  text = 'Refresh',
  opportunity,
  onRefreshStart,
  onRefreshComplete
}) => {
  const { fetchOpportunities } = useFetchOpportunities()
  const refreshOpportunity = useRefreshOpportunity()

  const onClick = async () => {
    if (onRefreshStart?.() === false) return
    await refreshOpportunity(opportunity?.Id)
    const opp = await fetchOpportunities({ opportunityId: opportunity?.Id })
    onRefreshComplete?.(opp)
  }

  return (
    <FaSync title={text} onClick={onClick} style={{ cursor: 'pointer' }} />
  )
}